import React, { useEffect, useState, useCallback } from 'react';
import DeliveryForm from '../../form/subscription/DeliveryForm';
import { getUser } from '../../api';
import useApplicationSession from '../../session/UserSession';

const Delivery = () => {
    const [userdata, setUserdata] = useState({ profile: null, payments: null });
    const token = useApplicationSession();
    const getUserInfo = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    const { profile, payments } = response.data;
                    setUserdata({ profile: profile, payments: payments });
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        getUserInfo();
    }, [getUserInfo]);

    return (
        <div test_id="subscription-delivery" className="subscriptionContentContainer">
            <DeliveryForm value={userdata} />
        </div>
    );
};

export default Delivery;
